import angular from 'angular';
import staticViewsConfig from "./static-views.config";

let staticViewsModule = angular.module('shared.components.staticViews', [])
  .config(staticViewsConfig);

export default staticViewsModule;



/** WEBPACK FOOTER **
 ** C:/Bitnami/wampstack-7.1.31-0/apache2/htdocs/toning/B2C/www/components/shared/components/static-views/static-views.js
 **/